import { UNLIMITED_AI_CREDITS_SENTINEL } from "@hex/common";

/** Rounds credit amounts for display (avoids float artifacts like 9.310000000000002). */
export const formatCreditsForDisplay = (value: number): string =>
  new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(value);

/**
 * Returns a number representing the fraction of credits used, where 0 represents 0% and 1 represents 100%
 * The returned value can exceed 1 if the user has used more credits than are available.
 */
export const getCreditUsagePercentage = (
  totalUserCreditsAvailable: number | typeof UNLIMITED_AI_CREDITS_SENTINEL,
  totalUserCreditsUsed: number,
): number => {
  // Handle the case where the user has unlimited credits, which should be treated as 0% used
  if (totalUserCreditsAvailable === UNLIMITED_AI_CREDITS_SENTINEL) {
    return 0;
  }
  // Handle the case where the user has no credits available, which should be treated as 100% used
  if (totalUserCreditsAvailable <= 0) {
    return 1;
  }
  return totalUserCreditsUsed / totalUserCreditsAvailable;
};
